<template>
    <form class="form-wrapper" @submit.prevent="submitForm">
        <div class="form-group__block">
            <InputGroup
                type="text"
                v-model="email"
                @input="sanitizeEmail"
                @blur="sanitizeEmail"
                :placeholder="$t('Your email')"
                required
                :maxLength="40"
                :inputName="'email'"
                autocomplete="email"
                :errorMessage="emailError"
                inputClass="form-control email-input email"
                customClass="field-email field-signupform-email"
            />
        </div>

        <div class="form-group__block">
            <InputGroup
                v-if="passwordInputType === 'password'"
                type="password"
                v-model="password"
                @input="sanitizePassword"
                @blur="sanitizePassword"
                @keydown="preventSpace"
                :placeholder="$t('Your password')"
                inputId="signup-form-password"
                required
                :isFocusedProp="isFocusedPassword"
                :maxLength="40"
                :errorMessage="passwordError"
                customClass="field-signupform-password password-container"
                inputClass="form-control password"
            />
            <InputGroup
                v-else
                type="text"
                v-model="password"
                @input="sanitizePassword"
                @blur="sanitizePassword"
                @keydown="preventSpace"
                :placeholder="$t('Your password')"
                inputId="signup-form-password"
                required
                :isFocusedProp="isFocusedPassword"
                :maxLength="40"
                :errorMessage="passwordError"
                customClass="field-signupform-password password-container"
                inputClass="form-control password"
            />
            <span class="view-password" :class="{active: passwordInputType == 'password'}" @click="togglePasswordVisibility"></span>
        </div>

        <div class="forgot-and-remember">
            <a class="login-form__forgot" href="" @click.prevent="$emit('change-type', 'reset')">{{ $t("Forgot Password?") }}</a>
        </div>
        <button
            type="submit"
            class="button button-accent login-btn btn-hover btn-hover--green"
            :class="{ 'not-changed' : !formValidation }"
        >
            <span v-if="!isSubmitting">
                {{ $t('Log in') }}
            </span>
            <div v-else class="btn-preloader btn-preloader--green"></div>
        </button>
        <div class="form-wrapper__link">
            <p>
                {{ $t('Not registered?') }}
                <span @click.prevent="$emit('change-type', 'signup')" class="link-class">
                    {{ $t('Sign Up') }}
                </span>
            </p>
        </div>
    </form>
</template>

<script>
import InputGroup from '/webpack-assets/vue/components/InputGroup.vue';

export default {
    components: {
        InputGroup,
    },
    props: {
        authData: {
            type: Object,
        }
    },
    data() {
        const minLengthLabelText = this.$t('At least {cnt} characters', { cnt: 8 });
        const specilaSymbolText = this.$t('At least one number (0-9) or special symbol');
        return {
            email: '',
            password: '',
            emailError: '',
            passwordError: '',
            agreeTerms: true,
            passwordInputType: 'password',
            formValidation: false,
            isValidMarkers: false,
            isSubmitting: false,
            isFocusedPassword: false,
            markers: [
                {
                    label: minLengthLabelText,
                    type: 'min-length',
                    value: 8,
                    isValid: false,
                },
                {
                    label: specilaSymbolText,
                    type: 'regex',
                    value: '^(?=.*\\d)|(?=.*(_|[^\\w])).+$',
                    isValid: false,
                },
            ],
        }
    },
    methods: {
        sanitizeInput(value) {
            if (value !== undefined && value !== null) {
                let valueString = value.toString();
                return valueString.replace(/[а-яА-ЯёЁ]/g, '');
            }
            return value;
        },
        sanitizeEmail(event) {
            const emailPattern = /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

            this.email = this.sanitizeInput(this.email);
            this.checkFormChange();

            if (this.email.length === 0) {
                this.emailError = this.$t('{title} cannot be blank', { title: this.$t('Email') });
            } else if (!emailPattern.test(this.email)) {
                this.emailError = this.$t('Please enter a valid email address.');
            } else {
                this.emailError = '';
            }
            this.checkCountError()
        },
        sanitizePassword(event) {
            this.password = this.sanitizeInput(this.password);
            this.checkFormChange();
            if (this.password.length === 0) {
                this.isFocusedPassword = false;
                this.passwordError = this.$t('{title} cannot be blank', {title: this.$t('Password') });
            } else {
                this.isFocusedPassword = true;
                this.passwordError = '';
            }
            this.checkCountError()
        },
        checkCountError() {
            if(this.emailError !== '' && this.passwordError !== '') {
                this.$emit('change-height-block', 34)
            } else if (this.emailError !== '' || this.passwordError !== '') {
                this.$emit('change-height-block', 17) 
            } else {
                this.$emit('change-height-block', 0) 
            }
        },
        handleSelectCurrency(value) {
            this.selectedCurrency = value;
        },
        handleSelectCountry(value) {
            this.selectedCountry = value;
        },
        checkFormChange() {
            this.formValidation = 
                    this.email.length && 
                    this.password.length &&
                    !this.emailError &&
                    !this.passwordError;
        },
        handleValidationStatus(isValid) {
            this.isValidMarkers = isValid;
        },
        togglePasswordVisibility() {
            this.passwordInputType = this.passwordInputType == 'password' ? 'text' : 'password';
        },
        togglePasswordConfirmVisibility() {
            this.passwordConfirmInputType = this.passwordConfirmInputType == 'password' ? 'text' : 'password';
        },
        async submitForm() {
            const formData = new FormData();
            const tokenInputs = document.querySelectorAll('input[name="cf-turnstile-response"]');
            const turnstileTokenInput = tokenInputs.length ? tokenInputs[tokenInputs.length - 1] : null;

            const emailInput = this.$el.querySelector('input.email');
            const passwordInput = this.$el.querySelector('input.password');
            if (emailInput && emailInput.value && !this.email) {
                this.email = emailInput.value;
            }
            if (passwordInput && passwordInput.value && !this.password) {
                this.password = passwordInput.value;
            }

            this.sanitizeEmail()
            this.sanitizePassword()
            if (this.isSubmitting || !this.formValidation) return;
            this.isSubmitting = true;

            formData.append('LoginForm[login]', this.email);
            formData.append('LoginForm[password]', this.password);
            formData.append('_csrf-frontend', this.authData.csrf);

            if (turnstileTokenInput && turnstileTokenInput.value !== '') {
                formData.append('LoginForm[recaptcha]', turnstileTokenInput.value);
            } else {
                this.isSubmitting = false;
                return;
            }
            if(this.email !== '' &&  this.password !== '') {
                this.$emit('captcha-token', true);
            }

            try {
                const response = await this.$request(`/${this.authData?.language}/auth-api/modal-login`, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-Token': this.authData.csrf,
                    },
                    body: formData
                });

                const resp = await response.json();
                this.$emit('captcha-token', false);
                if (resp.status === 'error') {
                    this.$emit('update-captcha-token');
                    this.emailError = resp.errors.login ? resp.errors.login[0] : '';
                    this.passwordError = resp.errors.password ? resp.errors.password[0] : '';
                    this.checkCountError()
                } else if (resp.status === 'success') {
                    this.checkCountError()
                    if (resp.isTwoFA) {
                        this.$emit('update-is-two-fa', {
                            status: true,
                            type: 'login',
                            emailUser: resp.email,
                            ttl: resp.ttl,
                            isEmailVerified: resp.isEmailVerified,
                            all: 2,
                            current: 2
                        });
                    } else {
                        this.$emit('auth-success', resp);
                        this.$emit('update-form-loader', true);
                    }
                }
            } catch (error) {
                this.$emit('update-captcha-token');
                console.error(error);
                this.$emit('captcha-token', false);
            } finally {
                setTimeout(() => {
                    this.$emit('captcha-token', false);
                }, 2500);
                this.isSubmitting = false;
            }
        },
    },
    computed: {
        selectedCurrency() {
            return this.authData?.default_currency;
        },
        selectedCountry() {
            return this.authData?.default_country;
        },
        getFilterCurrency() {
            return this.authData?.currencies;
        },
        getFilterCountry() {
            return this.authData?.countries;
        },
        company_name() {
            return this.authData?.company_name;
        }
    }

}
</script>

<style scoped lang="scss">
.form-wrapper {
    .form-group__block {
        margin-bottom: 20px;
        &:first-of-type {
            margin-bottom: 0;
        }
        &:last-of-type {
            margin-bottom: 0;
        }
    }
}
.form-input {
    &.email-input {
        padding-left: 48px !important;
    }
}
.forgot-and-remember {
    margin-top: -15px !important;
    margin-bottom: 0;
}
.login-form__forgot {
    color: #4E8AFF !important;
    font-family: 'Avenir-Next', sans-serif;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    transition: color 0.3s;
    &:hover {
        color: #1767FF !important;
    }
}
.button.button-accent.login-btn {
    margin-top: 20px;
    height: 50px;
}
.link-class {
    color: #4E8AFF !important;
    font-family: 'Avenir-Next', sans-serif;
    transition: color 0.3s;
    &:hover {
        color: #1767FF !important;
    }
}
:deep(.form-wrapper__link) {
    p, span {
        font-size: 16px !important;
        line-height: 24px !important;
        color: #9D9D9D !important;
    }
    span.link-class {
        color: #4E8AFF !important;
        font-weight: 300 !important;
        transition: color 0.3s;
        &:hover {
            color: #1767FF !important;
        }
    }
}
</style>